import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import LinearProgressWrapper from './LinearProgressWrapper';

function LoadingWrapper({ loading, children }) {
  if (loading)
    return (
      <Box>
        <LinearProgressWrapper />
      </Box>
    );
  else return children;
}

LoadingWrapper.propTypes = {
  loading: PropTypes.bool.isRequired,
  children: PropTypes.node
};

export default LoadingWrapper;
